__turbopack_context__.v({
  "metrics": "metrics-module-scss-module__rPNaoa__metrics",
});
